import {
  Box,
  Tab as MuiTab,
  Tabs as MuiTabs,
  styled,
  tabClasses,
  tabsClasses,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

export const IntegrationsTabsRow = styled(MuiTabs)(({ theme }) => ({
  minHeight: '2.5rem',
  borderBottom: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  [`.${tabsClasses.indicator}`]: {
    backgroundColor: theme.palette.custom.OV.sys.onSurface,
    height: '2px',
  },
}));

export const IntegrationsTab = styled(MuiTab)(({ theme }) => ({
  minHeight: '2.5rem',
  padding: theme.spacing(1, 2),
  textTransform: 'uppercase',
  fontSize: '0.75rem',
  letterSpacing: '0.04em',
  fontWeight: 500,
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  [`&.${tabClasses.selected}`]: {
    color: theme.palette.custom.OV.sys.onSurface,
    fontWeight: 600,
  },
}));

export const IntegrationsCardsScrollArea = styled(Box)({
  flexGrow: 1,
  overflow: 'auto',
  margin: '1rem 0',
});

export const IntegrationsCardsContainer = styled(Grid)({});
